export const classes = {
  backWrapper: 'mt-7',
};
